import { defineComponent, watch } from 'vue'
import type { ITweenedNumberProps } from './types'
import { reactive } from 'vue'
import { toNumber } from '@/utils/number'
import gsap from 'gsap'
import { numberToHumanReadable } from '@/utils/formatting/number'

const TweenedNumber = defineComponent<ITweenedNumberProps>({
  name: 'TweenedNumber',
  setup(props) {
    const { value, precision } = props
    const tweened = reactive({
      number: value
    })

    watch(props, (n) => {
      console.log({ n })
      gsap.to(tweened, { duration: props.duration || 0.25, number: toNumber(n.value) || 0 })
    })

    return () => {
      return (
        <span>
          {numberToHumanReadable(
            toNumber(tweened.number),
            precision || 2,
            undefined,
            undefined,
            false
          )}
        </span>
      )
    }
  }
})

TweenedNumber.props = ['value', 'duration']

export default TweenedNumber
